
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 60","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M44.565 12.5h-29.13c-2.135 0-3.288 2.505-1.898 4.127l10.861 12.67A2.5 2.5 0 0125 30.926v12.53a2.5 2.5 0 001.382 2.236l5 2.5c1.662.831 3.618-.378 3.618-2.236v-15.03a2.5 2.5 0 01.602-1.627l10.86-12.671c1.39-1.622.238-4.127-1.898-4.127z"}})])
          )
        }
      }
    